<template>
  <v-toolbar
    :class="{ 'drawer-open': $vuetify.breakpoint.mdAndUp && appDrawerOpen, 'events-open': $vuetify.breakpoint.lgAndUp && eventsDrawerOpen, 'working-bar': true, 'elevation-0': true, 'toolbar-title': true }"
    dense
    fixed
  >
    <v-toolbar-title>
      <v-subheader class="text-capitalize">
        <template v-if="options.previous">
          <router-link
            :to="{ name: options.previous.url }"
            class="mr-4 previous-page-link"
          >
            {{ $t(options.previous.text) }}
          </router-link>
        </template>

        {{ $t(options.title) }}
      </v-subheader>
    </v-toolbar-title>

    <v-spacer />

    <template v-for="(action, i) in options.actions">
      <v-btn
        v-if="!action.hidden"
        :key="i"
        :disabled="!!action.disabled"
        :loading="!!action.loading"
        :color="action.color || 'primary'"
        small
        flat
        class="text-uppercase white--text"
        @click="$radio.$emit(`action-panel-click-${action.event}`)"
      >
        {{ $t(action.text) }}
      </v-btn>
    </template>
  </v-toolbar>
</template>
<script>
export default {
  name: 'ActionsToolbar',

  data () {
    return {
      dialog: false,
      appDrawerOpen: true,
      eventsDrawerOpen: false,
      options: {
        previous: null,
        title: '',
        actions: []
      }
    }
  },

  mounted () {
    this.$radio.$on('action-panel-actions', (actions) => {
      this.options.actions = actions
    })
    this.$radio.$on('action-panel-actions-update', ({ event, action }) => {
      const btn = this.options.actions.find(a => a.event === event)
      Object.assign(btn, action)
      this.options.actions = this.options.actions.map(item1 => {
        const found = [btn].find(item2 => item1.event === item2.event)
        return found ? Object.assign(item1, found) : item1
      })
    })
    this.$radio.$on('action-panel-previous', (previous) => {
      this.options.previous = previous
    })
    this.$radio.$on('action-panel-title', (title) => {
      this.options.title = title
    })
    this.$radio.$on('app-drawer-state', ({ open: isOpen }) => {
      this.appDrawerOpen = isOpen
    })
    this.$radio.$on('events-drawer-state', ({ open: isOpen }) => {
      this.eventsDrawerOpen = isOpen
    })
  }
}
</script>

<style scoped>
  .working-bar {
    top: 48px;
    border-bottom: 1px solid #DCDCDC !important;
    border-top: 1px solid #DCDCDC !important;
    /*z-index: 500;*/
  }
  .toolbar-title {
    transition: padding-left .6s;
  }
  .drawer-open {
    padding-left: 225px !important;
  }
  .events-open {
    padding-right: 360px !important;
  }
  .previous-page-link {
    text-decoration: none;
  }
</style>
